module.exports = __webpack_public_path__ + "img/imgsierrac.58689d47.png";